<template>
  <v-list-tile @click.stop="$refs.logoutConfirmation.openDialog()">
    <v-list-tile-action class="px-0">
      <v-icon class="error--text cursor-pointer">
        logout
      </v-icon>
    </v-list-tile-action>
    <v-list-tile-content class="cursor-pointer">
      <v-list-tile-title>{{ $t('message.logOut') }}</v-list-tile-title>
    </v-list-tile-content>
    <app-confirmation-dialog
      ref="logoutConfirmation"
      :is-heading-enabled="false"
      :message="$t('message.logoutConfirmationPrompt')+' ?'"
      @onConfirm="logoutUser"
      @onCancel="$refs.logoutConfirmation.close()"
      confirm-color="primary"
      :confirm-text="$t('message.yes')"
      cancel-color="primary"
      :cancel-text="$t('message.no')"
    />
  </v-list-tile>
</template>
<script>
import { mapActions } from 'vuex';
import AppConfirmationDialog from 'Components/AppConfirmationDialog/AppConfirmationDialog';
import { clearBizgainState } from 'Features/bizgainOnboarding/helpers/commonHelper';
import {
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileAction,
  VIcon
} from 'vuetify/lib';
export default {
  methods: {
    ...mapActions([
      'resetSettingsMenu'
    ]),
    logoutUser() {
      this.$store.dispatch('logoutUser', this.$router);
      this.$refs.logoutConfirmation.close();
      this.resetSettingsMenu();
      clearBizgainState();
    }
  },
  components: {
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileAction,
    VIcon,
    AppConfirmationDialog
  }
};
</script>